import { Box, Stack, Skeleton } from '@mui/material';

const BuyerByOrder : React.FC<any> = ({ data }) => {


    const stylesHeader : any = {
        border: '1px solid #000', 
        textAlign: 'center',
        height : '40px',
        pt: 1,
        fontWeight : 500,
        backgroundColor: '#64b5f6'
    }

    const stylesColumnLeft : any  = {
        borderBottom: '1px solid #000', 
        borderLeft: '1px solid #000', 
        textAlign: 'center',
        width : '100%',
        padding: '5px 0'

    }

    const stylesColumn : any  = {
        borderBottom: '1px solid #000', 
        borderLeft: '1px solid #000', 
        borderRight: '1px solid #000', 
        textAlign: 'center',
        width : '100%',
        padding: '5px 0'

    }

    return (
        <Box pt={2}>
            { data.loading ?
                <Box>
                    <Skeleton height={70} variant="rectangular" />
                </Box>
                :
                <Box>
                    <Box sx={stylesHeader} >Buyer by Order Value</Box>
                    { data.data.buyer ? 
                    <Stack flexDirection="row" justifyContent="space-between">
                        <Box sx={{width: '100%'}}>
                            <Box sx={stylesColumnLeft}>Seller</Box>
                            { data.data.buyer.map((data : any,i :any) => (
                                <Box sx={stylesColumnLeft} key={i} fontSize={12}>{data.buyerName}</Box>
                            )) }
                        </Box>
                        <Box sx={{width: '100%'}}>
                            <Box sx={stylesColumn}>Total</Box>
                            { data.data.buyer.map((data : any,i :any) => (
                                <Box sx={stylesColumn} key={i} fontSize={12}>Rp. {data.total.toLocaleString()}</Box>
                            )) }
                        </Box>
                    </Stack> : null }
                </Box>
            }
        </Box>
    )
}

export default BuyerByOrder
